import BGPH1 from "../../../assets/images/backgrounds/bnrimage.jpg";
import moment from "moment/moment";
import { TableHeader, Pagination, Search } from '../../DataTable';
import "react-datepicker/dist/react-datepicker.css";
import Navbar from "../../Navbar/Main";
import Footer from "../../Footer/Main";
import ExportButton from "../../excel_export";
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import flagUrls from "../flags"; // should map codes like { USD: '/flags/us.svg', ... , default: '/flags/default.svg' }
// import BGPH1 from "../../../assets/images/backgrounds/bnrimage.jpg";

export const ExchangeRateHis = () => {
  const today = new Date(); // current date
  const [currency_name, setCurrName] = useState(""); // e.g. "USD"
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [currency, setCurrency] = useState([]);      // API results
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [data, setData] = useState([]);              // currency options from /currencyselect
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const ITEMS_PER_PAGE = 57;

  // Columns configuration (match your data shape)
  const headers = [
    { name: "Flag", field: "flag", sortable: false },
    { name: "Currency", field: "currency_name", sortable: true },
    { name: "Buying Rate", field: "buying_rate", sortable: true },
    { name: "Selling Rate", field: "selling_rate", sortable: true },
    { name: "Date", field: "post_date", sortable: true },
  ];

  // Load currency options (dropdown)
  useEffect(() => {
    fetch("/currencyselect")
      .then((response) => response.json())
      .then((json) => {
        setData(json || []);
        // If you want a default selection, pick first option if present
        if (!currency_name && Array.isArray(json) && json.length > 0) {
          setCurrName(json[0].currency_name);
        }
      })
      .catch(() => {})
      .finally(() => {});
  }, []); // eslint-disable-line

  // Submit form -> fetch history
// Helper: fetch history
const fetchHistory = async (curr, start, end) => {
  if (!curr || !start || !end) return;
  setLoading(true);
  setError("");

  try {
    const url = `https://fxrates.bnr.rw/currency_history/?currency_name=${encodeURIComponent(
      curr
    )}&start_date=${moment(start).format("DD/MM/YYYY")}&end_date=${moment(
      end
    ).format("DD/MM/YYYY")}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch currency history.");
    const parseResponse = await response.json();

    setCurrency(Array.isArray(parseResponse) ? parseResponse : []);
    setCurrentPage(1);
  } catch (err) {
    setError(err.message || "Something went wrong.");
    setCurrency([]);
  } finally {
    setLoading(false);
  }
};

// Submit handler (keeps working for manual search)
const onSubmitForm = async (e) => {
  e.preventDefault();
  await fetchHistory(currency_name, startDate, endDate);
};

// Auto-load today’s data once defaults are ready
useEffect(() => {
  if (currency_name && startDate && endDate) {
    fetchHistory(currency_name, startDate, endDate);
  }
}, [currency_name, startDate, endDate]);

  // Helpers for sorting
  const compareValues = (a, b, field) => {
    if (field === "currency_name") {
      return a.localeCompare(b);
    }
    if (field === "buying_rate" || field === "selling_rate" || field === "middle_rate") {
      const na = parseFloat(a ?? 0);
      const nb = parseFloat(b ?? 0);
      if (na === nb) return 0;
      return na > nb ? 1 : -1;
    }
    if (field === "post_date") {
      // API returns "DD/MM/YYYY" -> parse with moment
      const da = moment(a, "DD/MM/YYYY").toDate();
      const db = moment(b, "DD/MM/YYYY").toDate();
      if (da.getTime() === db.getTime()) return 0;
      return da > db ? 1 : -1;
    }
    // Fallback string compare
    return String(a ?? "").localeCompare(String(b ?? ""));
  };

  // Compute table data (filter, sort, paginate)
  const currencyData = useMemo(() => {
    let computed = currency || [];

    // Search filter (currency or date)
    if (search) {
      const q = search.toLowerCase();
      computed = computed.filter(
        (row) =>
          (row.currency_name || "").toLowerCase().includes(q) ||
          (row.post_date || "").toLowerCase().includes(q)
      );
    }

    // Sorting
    if (sorting.field) {
      const dir = sorting.order === "asc" ? 1 : -1;
      computed = [...computed].sort((x, y) => dir * compareValues(x[sorting.field], y[sorting.field], sorting.field));
    }

    setTotalItems(computed.length);

    // Pagination slice
    return computed.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [currency, search, sorting, currentPage]);

  return (
    <>
      <Navbar />
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>

      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            <li><Link to="/">Home</Link></li>
            <li><span>Exchange Rate Table</span></li>
          </ul>
        </div>
      </section>

      <section className="service-five pt-50 pb-50">
        <div className="container">
          <div className="row row-gutter-y-10 service-four__inner">
            <div className="loan-comparison__body" id="compare-emi-1">
              <div className="row">
                <form onSubmit={onSubmitForm} className="p-3 border rounded bg-light">
                  <div className="row g-3 align-items-end">
                    {/* Currency select */}
                    <div className="col-md-3">
                      <label htmlFor="currencySelect" className="form-label small text-muted">
                        Select Currency
                      </label>
                      <select
                        id="currencySelect"
                        className="form-select form-select-sm"
                        value={currency_name}
                        onChange={(e) => setCurrName(e.target.value)}
                        required
                      >
                        <option value="">Select Currency...</option>
                        {data.map((item) => (
                          <option key={item.id || item.currency_name} value={item.currency_name}>
                            {item.currency_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Start Date */}
                      <div className="col-md-2">
                        <label htmlFor="startDate" className="form-label small text-muted">
                          Start Date
                        </label>
                        <DatePicker
                          id="startDate"
                          className="form-control form-control-sm"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          maxDate={today}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Start Date"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          required
                        />
                      </div>

                      {/* End Date */}
                      <div className="col-md-2">
                        <label htmlFor="endDate" className="form-label small text-muted">
                          End Date
                        </label>
                        <DatePicker
                          id="endDate"
                          className="form-control form-control-sm"
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          maxDate={today}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="End Date"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          required
                        />
                      </div>


                    {/* Search button */}
                    <div className="col-md-2 d-flex gap-2">
                       <Link className="thm-btn-ccy" to="https://fxrates.bnr.rw/" target="_blank" rel="noreferrer">
                      API Access
                    </Link>
                    </div>

                    {/* Export button */}
                    <div className="col-md-2 d-flex gap-2">
                      <ExportButton data={currency} fileName="currency_table.xlsx" />
                    </div>
                  </div>
                </form>

              </div>

              {error && (
                <div className="alert alert-danger mt-3" role="alert">
                  {error}
                </div>
              )}

              <br />

              <div className="compare-table table-responsive" style={{ maxHeight: "70vh" }}>
                      {loading ? (
                        <p>Loading...</p>
                      ) : currencyData && currencyData.length > 0 ? (
                        <table className="table table-striped table-hover">
                          <TableHeader
                            headers={headers}
                            onSorting={(field, order) => {
                              setSorting({ field, order });
                              setCurrentPage(1);
                            }}
                          />
                          <tbody>
                            {currencyData.map((p) => (
                              <tr key={`${p.currency_name}-${p.post_date}-${p.id || Math.random()}`}>
                                <td>
                                  <img
                                    src={flagUrls[p.currency_name] || flagUrls.default || "/default-flag.png"}
                                    alt={p.currency_name}
                                    style={{ width: "30px", height: "20px" }}
                                  />
                                </td>
                                <td>{p.currency_name}</td>
                                <td>{p.buying_rate}</td>
                                <td>{p.selling_rate}</td>
                                <td>{p.post_date}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p>No records found</p>
                      )}
                    </div>

              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>
      </section>

      <Link to="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fa fa-angle-up"></i>
      </Link>
      <Footer />
    </>
  );
};

export default ExchangeRateHis;
